<script>
import Icon from '~/components/icon.vue';

import TotalAmount from './total_amount.vue';

export default {
  components: {
    Icon,
    TotalAmount
  },

  props: {
    isChecked: {
      type: Boolean,
      required: true
    },

    type: {
      type: String,
      required: true
    },

    title: {
      type: String,
      required: true
    }
  },

  emits: ['update:payment-type'],

  computed: {
    labelFor() {
      return `payment_type_${this.type}`;
    },
  },
};
</script>

<template>
  <div class="col-6">
    <label :for="labelFor">
      <input
        :id="labelFor"
        :value="type"
        :checked="isChecked"
        type="radio"
        name="payment_type"
        autocomplete="off"
        @change="$emit('update:payment-type', type)"
      >

      <div class="c-payment-type-tabs__item">
        <div class="c-checkmark c-payment-type-tabs__item__checkmark">
          <icon
            name="check"
            size="small"
          />
        </div>

        <div class="d-flex flex-column align-items-center justify-content-center">
          <div class="c-payment-type-tabs__text">
            {{ title }}
          </div>

          <div class="c-payment-type-tabs__amount">
            <total-amount
              :payment-type="type"
              :is-product-only="true"
            />
          </div>
        </div>
      </div>
    </label>
  </div>
</template>
